let debounceTimer = null;
const DEBOUNCE_MS = 3000;
/** Диспатчится из App после записи новых outbox-изменений. */
export const OUTBOX_CHANGED_EVENT = 'budgetcal:outbox-changed';
export function setupSyncTriggers(engine) {
    const onOnline = () => engine.triggerSync();
    const onFocus = () => {
        if (document.visibilityState === 'visible')
            engine.triggerSync();
    };
    // Локальная правка попала в outbox: сразу отражаем pending на бэдже
    // (чтобы не горел зелёным) и планируем авто-отправку.
    const onOutboxChanged = () => {
        engine.refreshCounts();
        debouncedSync(engine);
    };
    window.addEventListener('online', onOnline);
    document.addEventListener('visibilitychange', onFocus);
    window.addEventListener(OUTBOX_CHANGED_EVENT, onOutboxChanged);
    return () => {
        window.removeEventListener('online', onOnline);
        document.removeEventListener('visibilitychange', onFocus);
        window.removeEventListener(OUTBOX_CHANGED_EVENT, onOutboxChanged);
        if (debounceTimer)
            clearTimeout(debounceTimer);
    };
}
export function debouncedSync(engine) {
    if (debounceTimer)
        clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => engine.triggerSync(), DEBOUNCE_MS);
}
